import { render, staticRenderFns } from "./textleft.vue?vue&type=template&id=013f6b39&"
import script from "./textleft.vue?vue&type=script&lang=js&"
export * from "./textleft.vue?vue&type=script&lang=js&"
import style0 from "./textleft.vue?vue&type=style&index=0&id=013f6b39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports